import { ProjectType } from "./Types";
import { useBackendApi } from "./backendApi";
import { useEventsPublisher } from 'event-bus';
import { useSetupAreaIdContext } from './SetupAreaIdContext';

export const PROJECT_CLOSING_DATE_FIELD_UPDATED = 'PROJECT_CLOSING_DATE_FIELD_UPDATED';

export function useProjectClosingDateFieldService() {
  const backendApi = useBackendApi();

  const eventsPublisher = useEventsPublisher();

  const context = useSetupAreaIdContext();

  const getSetupAreaIdParams = (setupAreaId?: number | string) => {
    setupAreaId = setupAreaId || context?.setupAreaId;

    if (setupAreaId) {
      return `?setupAreaId=${setupAreaId}`;
    }
    return '';
  }

  const updateIsClosingDateField = async (
    projectType: ProjectType,
    fieldId: number,
    isClosingDateField: boolean,
    setupAreaId?: number | string,
  ) => {
    await backendApi.put(`/settings/projects/${projectType.toLowerCase()}/detailfields/${fieldId}/closingdatefield${getSetupAreaIdParams(setupAreaId)}`, {
      isClosingDateField,
    });
    eventsPublisher.publish(PROJECT_CLOSING_DATE_FIELD_UPDATED, {
      projectType,
    });
  };

  return {
    updateIsClosingDateField,
  }
}
